import { FC, HTMLProps, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { TextFieldProps } from '@mui/material';

import { TextField } from './TextField';

export type SelectOption = Pick<HTMLProps<HTMLOptionElement>, 'disabled' | 'value'> & {
  label: ReactNode;
};

export type SelectProps = Omit<TextFieldProps, 'children' | 'select' | 'SelectProps' | 'type'> & {
  defaultOption?: SelectOption;
  options: SelectOption[];
};

export const defaultSelectValue = -1;

export const Select: FC<SelectProps> = ({ defaultOption, options, value, ...rest }) => {
  const { t } = useTranslation();

  const defaultValue =
    defaultOption?.value === '' || defaultOption?.value != null
      ? defaultOption?.value
      : defaultSelectValue;

  return (
    <TextField
      select
      value={value !== '' && value != null ? value : defaultValue}
      {...rest}
      slotProps={{ select: { native: true } }}
    >
      <option defaultChecked disabled={defaultOption?.disabled ?? true} value={defaultValue}>
        {defaultOption?.label ?? t('select.default')}
      </option>

      {options.map(({ value, label, ...option }) => (
        <option key={value?.toString()} value={value} {...option}>
          {label}
        </option>
      ))}
    </TextField>
  );
};
